module.exports = {
  title: '青海省疾病预防控制中心实验室信息管理系统',
  base_title: '青海省疾病预防控制中心综合信息管理',
  lab_title: '青海省疾病预防控制中心实验室检测管理',
  oa_title: '青海省疾病预防控制中心人员管理',
  stock_title: '青海省疾病预防控制中心库存管理',
  budget_title: '青海省疾病预防控制中心资金预算管理',
  adm_title: '青海省疾病预防控制中心行政管理',
  purchase_title: '青海省疾病预防控制中心采购管理',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
